import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Spinner, Alert } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'

import { add } from '../../controller/api/device'
import { DEVICE_STATUS, DEVICE_STATUS_OPTIONS } from '../../helper/deviceStatus'

export const AddDeviceModal = ({ show, onHide, onAddSuccess }) => {
  const [cookies] = useCookies(['lottmekong'])
  const [code, setCode] = useState('')
  const [name, setName] = useState('')
  const [status, setStatus] = useState(DEVICE_STATUS.READY)
  const [adding, setAdding] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (show) {
      setCode('')
      setName('')
      setStatus(DEVICE_STATUS.READY)
      setError('')
    }
  }, [show])

  const trimmedCode = code.trim()
  const trimmedName = name.trim()
  const canSubmit = trimmedCode && trimmedName && !adding

  const handleAdd = async () => {
    if (!canSubmit) return

    setAdding(true)
    setError('')

    const result = await add(cookies.lottmekong, trimmedCode, trimmedName, status)

    setAdding(false)

    if (result && result.status === 'success') {
      onAddSuccess && onAddSuccess()
      onHide()
      return
    }

    setError(result?.message || 'Không thể thêm thiết bị')
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Thêm thiết bị USB</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Mã thiết bị</Form.Label>
          <Form.Control
            type="text"
            placeholder="VD: MAY3"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            disabled={adding}
          />
          <Form.Text className="text-muted">
            Mã này phải trùng với mã cấu hình trên thiết bị USB.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Tên thiết bị</Form.Label>
          <Form.Control
            type="text"
            placeholder="VD: Máy in 3"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={adding}
          />
        </Form.Group>

        <Form.Group className="mb-0">
          <Form.Label>Trạng thái</Form.Label>
          <Form.Select
            value={status}
            onChange={(e) => setStatus(Number(e.target.value))}
            disabled={adding}
          >
            {DEVICE_STATUS_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={adding}>
          Hủy
        </Button>
        <Button variant="primary" onClick={handleAdd} disabled={!canSubmit}>
          {adding ? <Spinner animation="border" size="sm" /> : 'Thêm thiết bị'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddDeviceModal
